import moment from 'moment'
import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/Crm/csi'

export default {
  namespaced: true,
  state: {
    loading: false,
    loadingAll: false,
    reportData: {
      monthly: [],
      yearly: 0,
      chartData: {
        series: [],
      },
    },
    reportDataAll: [],
    filterItems: {
      brands: [],
      departments: [],
      locations: [],
      years: [],
    },
    /* Filter Params */
    filterParams: {
      year: `${moment().format('YYYY')}`,
      id_com_department: null,
      id_com_brand: null,
      id_com_locations: null,
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    loadingAll(state) {
      return state.loadingAll
    },
    reportData(state) {
      return state.reportData
    },
    reportDataAll(state) {
      return state.reportDataAll
    },
    filterItems(state) {
      return state.filterItems
    },
    /* Filter Params */
    filterParams(state) {
      return state.filterParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_LOADING_ALL(state, data) {
      state.loadingAll = data
    },
    SET_REPORT_DATA(state, data) {
      state.reportData = data
    },
    SET_REPORT_DATA_ALL(state, data) {
      state.reportDataAll = data
    },
    SET_FILTER_ITEMS(state, data) {
      state.filterItems = data
    },
    /* RESET MUTATIONS */
    RESET_REPORT_DATA(state) {
      state.reportData = {
        monthly: [],
        yearly: 0,
        chartData: {
          series: [],
        },
      }
    },
    RESET_REPORT_DATA_ALL(state) {
      state.reportDataAll = []
    },
  },
  actions: {
    getData({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_REPORT_DATA')
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_REPORT_DATA', response.data.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getDataAll({ commit }, params) {
      commit('SET_LOADING_ALL', true)
      commit('RESET_REPORT_DATA_ALL')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/csiAllData`, data)
        .then(response => {
          commit('SET_REPORT_DATA_ALL', response.data.data)
          commit('SET_LOADING_ALL', false)
        })
        .catch(error => console.error(error))
    },
    getFilterItems({ commit }, params) {
      commit('RESET_REPORT_DATA')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/getFilterItems`, data)
        .then(response => {
          commit('SET_FILTER_ITEMS', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
